import { LocalDateTime } from 'js-joda';

import { CalendarItem } from 'utils/calendarItems';
import { TableWithCalendarSquares } from 'types/tableBasedInventory';
import AppConstants from 'constants/AppConstants';

export interface FlexHoldDetails {
  anticipatedEndDateTime?: LocalDateTime;
  startDateTime?: LocalDateTime;
  isRequestInProgress: boolean;
  table: TableWithCalendarSquares;
  ticketGroupId?: number;
}

export interface FlexBlockDetails {
  anticipatedEndDateTime?: LocalDateTime;
  startDateTime?: LocalDateTime;
  isRequestInProgress: boolean;
  table: TableWithCalendarSquares;
  ticketGroupId?: number;
  action: 'ADD' | 'REMOVE';
}
export interface State {
  flexBlockDetails?: FlexBlockDetails;
  flexHoldDetails?: FlexHoldDetails;
  calendarItemToHold?: CalendarItem;
  showTicketSubsetHoldModal: boolean;
}

export const initialState: State = {
  flexBlockDetails: undefined,
  flexHoldDetails: undefined,
  calendarItemToHold: undefined,
  showTicketSubsetHoldModal: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.FLEX_BLOCKS_SET: {
      return {
        ...state,
        flexBlockDetails: payload,
      };
    }
    case AppConstants.FLEX_BLOCKS_CLEAR: {
      return {
        ...state,
        flexBlockDetails: undefined,
        flexHoldDetails: undefined,
        calendarItemToHold: undefined,
        showTicketSubsetHoldModal: false,
      };
    }
    case AppConstants.FLEX_HOLD_SET: {
      return {
        ...state,
        flexHoldDetails: payload,
      };
    }
    case AppConstants.CALENDAR_ITEM_HOLD_SET: {
      return {
        ...state,
        calendarItemToHold: payload,
      };
    }
    case AppConstants.CALENDAR_ITEM_SHOW_SUBSET_MODAL: {
      return {
        ...state,
        showTicketSubsetHoldModal: payload,
      };
    }
    default:
      return state;
  }
}
